<details class="dropdown">
  <summary role="button">
    <img class="avatar" [src]="avatarUrl | async" alt="User Avatar">
    <span class="user-label">{{displayName | async}}</span>
  </summary>
  <ul *ngIf="!isProduction">
    <li><a href="#" (click)="logout()">Logout</a></li>
  </ul>
</details>
